<widget-header
    [name]="widgetName"
    [editable]="isEditable">

  <widget-menu
      [resource]="resource">
  </widget-menu>
</widget-header>

<div class="grid--widget-content">
  <no-results *ngIf="noEntries"
              [title]="text.noResults">
  </no-results>
  <span *ngFor="let project of projects; let last = last">
    <a [href]="projectPath(project)"
       [textContent]="projectName(project)">
    </a>
    <span *ngIf="!last">, </span>
  </span>
</div>
